import React from "react"
import CustomDateInput from "components/Atoms/CustomDateInput"
import StringInput from "components/Atoms/StringInput"
import FilUploadCrop from "components/Molecules/FileUploadCrop"
import SectionHeader from "../SectionHeader"

const VehicleCertifications = () => {
  return (
    <>
      <SectionHeader title="Certifications" />
      <div className="grid grid-cols-12 gap-x-7">
        <div className="col-span-3">
          <StringInput
            helperText="eg. Tata AIG General Insurance."
            path="insurance.name"
            label="Issuing Authority"
          />
        </div>
        <div className="col-span-3">
          <StringInput label="Insurance Type" />
        </div>
        <div className="col-span-3">
          <CustomDateInput path="insurance.issuedOn" label="Issued On" />
        </div>
        <div className="col-span-3">
          <CustomDateInput path="insurance.validTill" label="Valid Till" />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-x-7 mt-3">
        <div className="col-span-3">
          <StringInput path="insurance.idNumber" label="Insurance Id" />
        </div>
        <div className="col-span-3">
          <FilUploadCrop
            foldername="registration"
            big
            label="Insurance Photo"
            path="insurance.photo"
          />
        </div>
      </div>
    </>
  )
}

export default VehicleCertifications
